import { StyleSheet, Text, Pressable } from 'react-native'
import React, { useEffect } from 'react'
import Animated, {FlipInYLeft, useAnimatedStyle, useSharedValue, withSpring} from 'react-native-reanimated'
import useSelectedRoutes from '../../hooks/useSelectedRoutes';
import { colors } from '../../colors';
import { displayFont } from '../../fonts';

const ReanimatedPressable = Animated.createAnimatedComponent(Pressable);

const Menu = ({text, setSelectedRoute, selectedRoute, compact, bar, ...props}) => {
  const leftPos = useSharedValue(0);
  // const perspectPos = useSharedValue(0);
  const setRoute = () =>  {
    setSelectedRoute(text)
    // perspectPos.value = '-' + withSpring(40) + 'deg'
  };

  const animatedStyles = useAnimatedStyle(() => {
    return {
      left: leftPos.value,
      // transform: [
      //     { perspective: 850 },
      //     { rotateY: perspectPos.value },
      // ],
    };
  });

  const hoverInMenu = () => leftPos.value = withSpring(20);

  const hoverOutMenu = () => leftPos.value = withSpring(0);

  // useEffect(()=>{
  //   // perspectPos.value = '-' + withSpring(40) + 'deg'
  // }, [])

  return (
    <ReanimatedPressable accessibilityRole="button" accessibilityState={{ selected: selectedRoute === text }} onPress={setRoute} onHoverIn={compact || bar ? undefined : hoverInMenu} onHoverOut={compact || bar ? undefined : hoverOutMenu} style={({ focused }) => [styles.container, compact && styles.compact, bar && styles.bar, selectedRoute === text && bar && styles.barActive, focused && styles.focused, animatedStyles]}>
      <Text numberOfLines={1} style={[styles.text, (compact || bar) && styles.compactText, bar && styles.barText, {fontSize: bar ? (compact ? 12 : 15) : compact ? 13 : (selectedRoute === text ? 28 : 20), fontWeight: selectedRoute === text ? '700' : '600', color: selectedRoute === text ? colors.red : '#FFFFFF', textAlign: compact || bar ? 'center' : 'left', ...(bar ? {whiteSpace: 'nowrap'} : {})}]}>{text}</Text>
    </ReanimatedPressable>
  )
}

export default Menu

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 10,
        justifyContent: 'center',
        // alignItems: 'center',
        margin: 20,
        marginLeft: 40,
        minHeight: 44,
        transform: [
          { perspective: 850 },
          { rotateY: '0deg'},
        ],
    },
    compact: {
        margin: 0,
        marginLeft: 0,
        paddingVertical: 12,
        paddingHorizontal: 4,
        flex: 1,
        alignItems: 'center',
    },
    bar: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto',
        margin: 0,
        marginLeft: 28,
        paddingVertical: 10,
        paddingHorizontal: 4,
        minHeight: 44,
        justifyContent: 'center',
        transform: [{ perspective: 850 }, { rotateY: '0deg' }],
    },
    barText: {
        whiteSpace: 'nowrap',
    },
    focused: {
        outlineWidth: 2,
        outlineStyle: 'solid',
        outlineColor: '#FFFFFF',
        outlineOffset: 2,
    },
    barActive: {
        borderBottomWidth: 2,
        borderBottomColor: colors.red,
    },
    compactText: {
        letterSpacing: 0.6,
    },
    text: {
        color: colors.text,
        fontFamily: displayFont,
        fontWeight: '600',
        fontSize: 24,
        letterSpacing: 0.5,
    }
})